import api from '../api';

export const getTasks = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  if (filters.assigneeId) queryParams.append('assigneeId', filters.assigneeId);
  if (filters.operationCaseId) queryParams.append('operationCaseId', filters.operationCaseId);
  if (filters.partyId) queryParams.append('partyId', filters.partyId);
  if (filters.leadId) queryParams.append('leadId', filters.leadId);
  if (filters.status) queryParams.append('status', filters.status);

  const response = await api.get(`/tasks?${queryParams.toString()}`);
  return response.data;
};

export const createTask = async (taskData) => {
  const response = await api.post(`/tasks`, taskData);
  return response.data;
};

export const updateTask = async (id, taskData) => {
  const response = await api.put(`/tasks/${id}`, taskData);
  return response.data;
};

export const deleteTask = async (id) => {
  const response = await api.delete(`/tasks/${id}`);
  return response.data;
};
